import { render, staticRenderFns } from "./emergencyHandleCard.vue?vue&type=template&id=5fa4895e&scoped=true&"
import script from "./emergencyHandleCard.vue?vue&type=script&lang=js&"
export * from "./emergencyHandleCard.vue?vue&type=script&lang=js&"
import style0 from "./emergencyHandleCard.vue?vue&type=style&index=0&id=5fa4895e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa4895e",
  null
  
)

export default component.exports